import {createContext, ReactNode, useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import {LogInPair, UserRole} from "types";
import {apiUrl} from "../config/api";
import {toast} from "react-toastify";

interface UserData {
  role: UserRole;
  id:string;
  email: string ;
}
interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

export interface AuthContextValues {
  user:UserData | null;
  isAuthenticated: boolean;
  login: (authInfo : LogInPair) => void;
  logout: () => void;
  changePassword: (passwordData: ChangePasswordData) => Promise<void>;
}
export const AuthContextUser = createContext<AuthContextValues>({
  user: null,
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
  changePassword: async () => {},
});

interface LoginErrorResponse {
  error: string;
  isAuthenticated: false;
}
interface Props {
  children: ReactNode,
}

const Provider = AuthContextUser.Provider;

export const AuthContextProvider = ({ children }:Props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const [user, setUser] = useState(() => {

    const userProfle = localStorage.getItem("jwt");

    if (userProfle) {
      setIsAuthenticated(true)
      return JSON.parse(userProfle);
    }
    return null;
  });

  const navigate = useNavigate();

  const login = async (payload: LogInPair) => {

    try {
      const apiResponse = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      if (!apiResponse.ok) {
        setUser(null);
        setIsAuthenticated(false);
        const errorResponse: LoginErrorResponse = await apiResponse.json();
        toast(`Niepoprawne dane ${errorResponse.error}`)
        throw new Error(errorResponse.error);
      }

      const result = await apiResponse.json();
      localStorage.setItem("jwt", JSON.stringify(result));
      setUser(result);
      setIsAuthenticated(true);
      navigate("/");

    } catch (error) {
        toast.error(`Błąd: Niepoprawne dane logowania`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    }
  };

  const logout = async () => {

    localStorage.removeItem("jwt");
    setUser(null);
    setIsAuthenticated(false)
    await fetch(`${apiUrl}/auth/logout`, {
          method: 'POST',
          credentials: "include",
        });
    toast.info("Wylogowano")
    navigate("/Login");
  };
  const changePassword = async (passwordData: ChangePasswordData) => {
    try {
      console.log('Wysyłam dane:', passwordData); 
      const apiResponse = await fetch(`${apiUrl}/user/change-password`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(passwordData),
      });
      console.log('Status:', apiResponse.status); // DODAJ TO
      if (!apiResponse.ok) {
        const errorResponse = await apiResponse.json();
        toast.error(errorResponse.message || 'Błąd podczas zmiany hasła', {
          position: "top-right",
          autoClose: 4000,
        });
        throw new Error(errorResponse.message);
      }

      const result = await apiResponse.json();

      toast.success(result.message || 'Hasło zostało zmienione pomyślnie!', {
        position: "top-right",
        autoClose: 3000,
      });

      // Wyloguj użytkownika po zmianie hasła
      setTimeout(() => {
        logout();
      }, 2000);

    } catch (error: any) {
      throw error;
    }
  };


  return (
     <Provider
         value={{
           user,
           isAuthenticated,
           login,
           logout,
           changePassword,
          }}
     >
        {children}
      </Provider>
  );
};
export default AuthContextProvider;